// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@conklin/App/GoogleAnalyticsConnector/Store/Reducers";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, PrepageProductRecs } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";

export const XngGaTrackNoStockProducts: typeof PrepageProductRecs = ({
    getState,
    dispatch,
    parameter: { isSearch },
    result: { products },
}) => {
    const state = getState();

    if (products?.length && isSearch && (state as xGoogleAnalyticsState).xGoogleAnalytics.noStockSearchEventName) {
        dispatch({
            type: "xGoogleAnalytics/setShouldTrackNoStockSearch",
            shouldTrackNoStockSearch: true,
        } as any);
    }
};

addToEndOfChain(chain, XngGaTrackNoStockProducts);
